export default [
  {
    path: '/merchants-settings',
    name: 'merchants_configuration',
    component: () =>
      import(
        /* webpackChunkName: 'merchants-settings' */ '@/modules/merchants/_views/Index'
      ),
    redirect: { name: 'merchants_settings' },
    children: [
      {
        name: 'merchants_settings',
        path: 'merchants-settings',
        meta: {
          section: 'merchants_settings',
          allowedRoles: ['ROLE_SUPER_ADMIN']
        },
        component: () =>
          import(
            /* webpackChunkName: 'merchants-configurations' */ '@/modules/merchants/_views/merchants/MerchantSettingsIndex'
          )
      },
      {
        name: 'activity_group_settings',
        path: 'activity-group-settings',
        meta: {
          section: 'merchants_settings',
          allowedRoles: ['ROLE_SUPER_ADMIN']
        },
        component: () =>
          import(
            /* webpackChunkName: 'activity-group-configurations' */ '@/modules/merchants/_views/activity_groups/ActivityGroupsSettingsIndex'
          )
      }
    ]
  }
]
